define('viewmodels/configuration/EmailTemplate',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'durandal/system', 'services/logger', 'viewmodels/GeneralSettings'],
    function (ko, router, appsecurity, navigation, app, system, logger, ObjGeneralSettings) {

        var ViewModel = {
            activate: activate,
            attached: attached,
            appsecurity: appsecurity,
            ObjGeneralSettings: ObjGeneralSettings,
            TemplateList: ko.observableArray([]),
            getTemplateDetails: getTemplateDetails,
            ControlsAccess: ko.observable(false),
            ShowAddRolePopUp: ShowAddRolePopUp,
            ShowEditRolePopUp: ShowEditRolePopUp,
            popUpTitle: ko.observable(''),
            addPopUpCss: ko.observable(false),
            TemplateName: ko.observable(''),
            TemplateBody: ko.observable(''),
            TemplateDescription: ko.observable(''),
            TemplateSubject: ko.observable(''),
            TemplateBCC: ko.observable(''),
            TemplateDisplayName: ko.observable(''),
            SaveNewTemplate: SaveNewTemplate,
            UpdateTemplate: UpdateTemplate,
            TemplateId: ko.observable(0),
            HasClientId: ko.observable(false),
            ClientFlag: ko.observable(),
            DeleteTemplatePopUp: DeleteTemplatePopUp,
            DeleteTemplate: DeleteTemplate,
            UsersList: ko.observableArray([]),
            ToList: ko.observableArray([]),
            CCList: ko.observableArray([]),
            BCCList: ko.observableArray([])
        };
        return ViewModel;

        function activate() {
            try {
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in LocalizationModule.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
                if (appsecurity.WriteAccess() == true) {
                    ViewModel.ControlsAccess(true);
                }
                else {
                    ViewModel.ControlsAccess(false);
                }
                getTemplateDetails();
                GetAllUsers();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in LocalizationModule.js';
                logger.logMessage(msg);
            }
        }

        function getTemplateDetails() {
            try {
                $('#tblTemplateDetails').hide();
                $('#loadingMainImgDiv').show();
                $.ajax({
                    url: "/api/Configuration/GetTemplateDetails",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: getScenarioDetails() method in YearSetup.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    //if (jsonResult.length > 0) {
                    var MappedTemplateDetails = $.map(jsonResult, function (result) {
                        return new TemplateModel(result);
                    });

                    $('#tblTemplateDetails').show();
                    $('#loadingMainImgDiv').hide();

                    tableObj = $('#tblTemplateDetails').DataTable();
                    tableObj.destroy();

                    $('#tblTemplateDetails tbody tr').remove();
                    QuestionTableObj = undefined;
                    ViewModel.TemplateList([]);
                    ViewModel.TemplateList(MappedTemplateDetails)
                    QuestionTableObj = $('#tblTemplateDetails').DataTable({
                        "order": [],
                        "aaSorting": [],
                        "bResponsive": true,
                    });

                    $('#tblTemplateDetails').DataTable().draw(false);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from getScenarioDetails() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getScenarioDetails() method in EmailTemplate.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from getScenarioDetails() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            }

        }

        function ShowAddRolePopUp(data, event) {
            try {
                ViewModel.popUpTitle("Add Template");
                ViewModel.addPopUpCss(true);
                ViewModel.TemplateName('');
                ViewModel.TemplateBody('');
                ViewModel.TemplateDescription('');
                ViewModel.TemplateSubject('');
                ViewModel.TemplateBCC('');
                ViewModel.TemplateDisplayName('');
                ViewModel.HasClientId(0);
                $('#CreateNewTemplate').modal('show');
                $('#selectToList').multiselect();
                $('#selectToList').multiselect('refresh');
                $('#selectCCList').multiselect();
                $('#selectCCList').multiselect('refresh');
                $('#selectBCCList').multiselect();
                $('#selectBCCList').multiselect('refresh');
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in ShowAddRolePopUp() method in EmailTemplate.js';
                logger.logMessage(msg);
            }
        }

        function SaveNewTemplate(data, event) {
            try {

                var ClientIdFlag = 0;
                if (ViewModel.HasClientId())
                    ClientIdFlag = 1;
                else
                    ClientIdFlag = 0;

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/configuration/CreateUpdateNewTemplate",
                    headers: headers,
                    type: "POST",
                    data: {
                        TemplateName: ViewModel.TemplateName(), TemplateSubject: ViewModel.TemplateSubject()
                        , TemplateBody: ViewModel.TemplateBody(), TemplateBCC: ViewModel.TemplateBCC()
                        , TemplateDisplayName: ViewModel.TemplateDisplayName(), ClientFlag: ClientIdFlag, TemplateId: 0
                        , TemplateDescription: ViewModel.TemplateDescription()
                        , CCList: $.map(ViewModel.CCList(), function (result) {
                            return { UserId: result };
                        }),
                        BCCList: $.map(ViewModel.BCCList(), function (result) {
                            return { UserId: result };
                        }),
                        ToList: $.map(ViewModel.ToList(), function (result) {
                            return { UserId: result };
                        })
                    }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in SaveNewTemplate() method in EmailTemplate.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult >= 1) {
                        logger.logSuccess('Email Template has been created successfully.', 'Success', system.getModuleId(ViewModel), true);
                        getTemplateDetails();
                        $('#CreateNewTemplate').modal('hide');
                    }
                    else
                        logger.logError('An error occurred while creating the template. Please contact your Administrator.', 'Error', system.getModuleId(ViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from SaveNewTemplate() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveNewTemplate() method in EmailTemplate.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from SaveNewTemplate() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            }
        }

        function ShowEditRolePopUp(data, event) {
            try {
                ViewModel.TemplateId(data.TemplateId());
                GetRecipients();
                ViewModel.popUpTitle("Edit Template");
                ViewModel.addPopUpCss(false);
                ViewModel.TemplateName(data.TemplateName());
                ViewModel.TemplateBody(data.TemplateBody());
                ViewModel.TemplateDescription(data.TemplateDescription());
                ViewModel.TemplateSubject(data.TemplateSubject());
                ViewModel.TemplateBCC(data.TemplateBCC());
                ViewModel.TemplateDisplayName(data.TemplateDisplayName());
                ViewModel.HasClientId(parseInt(data.ClientFlag()));
               
                $('#EditTemplate').modal('show');
                $('#editselectToList').multiselect();
                $('#editselectToList').multiselect('refresh');
                $('#editselectCCList').multiselect();
                $('#editselectCCList').multiselect('refresh');
                $('#editselectBCCList').multiselect();
                $('#editselectBCCList').multiselect('refresh');
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in ShowEditRolePopUp() method in EmailTemplate.js';
                logger.logMessage(msg);
            }
        }

        function UpdateTemplate(data, event) {
            try {

                var ClientIdFlag = 0;
                if (ViewModel.HasClientId())
                    ClientIdFlag = 1;
                else
                    ClientIdFlag = 0;

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/configuration/CreateUpdateNewTemplate",
                    headers: headers,
                    type: "POST",
                    data: {
                        TemplateName: ViewModel.TemplateName(), TemplateSubject: ViewModel.TemplateSubject()
                        , TemplateBody: ViewModel.TemplateBody(), TemplateBCC: ViewModel.TemplateBCC()
                        , TemplateDisplayName: ViewModel.TemplateDisplayName(), TemplateId: data.TemplateId(), ClientFlag: ClientIdFlag
                        , TemplateDescription: ViewModel.TemplateDescription()
                        , CCList: $.map(ViewModel.CCList(), function (result) {
                            return { UserId: result };
                        }),
                        BCCList: $.map(ViewModel.BCCList(), function (result) {
                            return { UserId: result };
                        }),
                        ToList: $.map(ViewModel.ToList(), function (result) {
                            return { UserId: result };
                        })
                    }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in UpdateTemplate() method in EmailTemplate.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult >= 1) {
                        logger.logSuccess('Email Template has been updated successfully.', 'Success', system.getModuleId(ViewModel), true);
                        getTemplateDetails();
                        $('#EditTemplate').modal('hide');
                    }
                    else
                        logger.logError('An error occurred while creating the template. Please contact your Administrator.', 'Error', system.getModuleId(ViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from UpdateTemplate() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in UpdateTemplate() method in EmailTemplate.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from UpdateTemplate() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            }
        }

        function DeleteTemplatePopUp(data, event) {
            try {
                app.showMessage('Are you sure you want to Delete this Template?', 'Delete Template - ' + data.TemplateName(), ['Confirm', 'Cancel'], false, { primaryButtonClass: "mr-2 btn-curved fa fa-check btn btn-success autofocus", secondaryButtonClass: "mr-2 btn-curved fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-trash text-default' })
                    .then(function (option) {
                        if (option === 'Confirm') {
                            DeleteTemplate(data, event);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteTemplatePopUp() method in EmailTemplate.js';
                logger.logMessage(msg);
            }
        }

        function DeleteTemplate(data, event) {

            try {
                csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/configuration/DeleteEmailTemplate?TemplateId=" + data.TemplateId(),
                    type: "POST",
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in DeleteTemplate() method in EmailTemplate.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (jsonResult == 1) {
                        getTemplateDetails();

                        logger.logSuccess('Template deleted successfully.', 'Success', system.getModuleId(ViewModel), true);
                    }
                    else
                        logger.logError('An error occurred while deleting Template. Please contact your Administrator', 'Error', system.getModuleId(ViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DeleteTemplate() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteTemplate() method in EmailTemplate.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteTemplate() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            };

        }
        function GetAllUsers() {
            try {
                $.ajax({
                    url: "/api/Configuration/GetAllUserForClient",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllUsers() method in EmailTemplate.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {

                    if (jsonResult != null) {
                        var mappedUserDetails = $.map(jsonResult, function (result) {
                            return new UserModel(result);
                        });
                        ViewModel.UsersList(mappedUserDetails);
                    }
                    else
                        logger.logError('An error occurred while fetching User details.', 'Error', system.getModuleId(UrViewModel), true);

                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllUsers() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllUsers() method in EmailTemplate.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllUsers() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            };
        }
        function GetRecipients() {
            try {
                ViewModel.ToList([]);
                ViewModel.CCList([]);
                ViewModel.BCCList([]);
                $.ajax({
                    url: "/api/Configuration/GetRecipients?templateId=" + ViewModel.TemplateId(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetRecipients() method in EmailTemplate.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult !== null) {
                        if (jsonResult.ToList !== null) {
                            var mappedToList = $.map(jsonResult.ToList, function (result) {
                                ViewModel.ToList.push(result.UserId);
                            });
                        }
                        if (jsonResult.CCList !== null) {
                            var mappedCCList = $.map(jsonResult.CCList, function (result) {
                                ViewModel.CCList.push(result.UserId);
                            });
                        }
                        if (jsonResult.BCCList !== null) {
                            var mappedBCCList = $.map(jsonResult.BCCList, function (result) {
                                ViewModel.BCCList.push(result.UserId);
                            });
                        }
                        $('#editselectToList').multiselect();
                        $('#editselectToList').multiselect('refresh');
                        $('#editselectCCList').multiselect();
                        $('#editselectCCList').multiselect('refresh');
                        $('#editselectBCCList').multiselect();
                        $('#editselectBCCList').multiselect('refresh');
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRecipients() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRecipients() method in EmailTemplate.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetRecipients() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            }
        }

        /************** Models ***************/
        function UserModel(item) {
            try {
                var self = this;
                self.UserId = ko.observable(item.UserId);
                self.UserName = ko.observable(item.UserName);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UserModel() method in EmailTemplate.js';
                logger.logMessage(msg);
            }
        }
        function TemplateModel(item) {
            try {
                var self = this;
                self.TemplateId = ko.observable($('<div/>').html(item.TemplateId).text());
                //self.TemplateOrder = ko.observable($('<div/>').html(item.TemplateOrder).text());
                self.TemplateName = ko.observable($('<div/>').html(item.TemplateName).text());
                self.TemplateBody = ko.observable($('<div/>').text(item.TemplateBody).text());
                self.TemplateSubject = ko.observable($('<div/>').html(item.TemplateSubject).text());
                self.TemplateBCC = ko.observable($('<div/>').html(item.TemplateBCC).text());
                self.TemplateDisplayName = ko.observable($('<div/>').html(item.TemplateDisplayName).text());
                self.TemplateClientId = ko.observable($('<div/>').html(item.TemplateClientId).text());
                self.ClientFlag = ko.observable($('<div/>').html(item.ClientFlag).text());
                self.TemplateDescription = ko.observable($('<div/>').text(item.TemplateDescription).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ScenarioModel() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }

    });


